import { useEffect, useState } from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";

interface Props {
  value: string;
  onChange: (cron: string) => void;
}

const ranges = {
  minute: Array.from({ length: 60 }, (_, i) => i),
  hour: Array.from({ length: 24 }, (_, i) => i),
  dayOfMonth: Array.from({ length: 31 }, (_, i) => i + 1),
  month: Array.from({ length: 12 }, (_, i) => i + 1),
  dayOfWeek: Array.from({ length: 7 }, (_, i) => i), // 0 (Sun) - 6 (Sat)
};

const CronBuilder = ({ value, onChange }: Props) => {
  const [minute, setMinute] = useState<string | number>("*");
  const [hour, setHour] = useState<string | number>("*");
  const [dayOfMonth, setDayOfMonth] = useState<string | number>("*");
  const [month, setMonth] = useState<string | number>("*");
  const [dayOfWeek, setDayOfWeek] = useState<string | number>("*");

  // Parse incoming cron string
  useEffect(() => {
    const [min, hr, dom, mon, dow] = value.split(" ");
    setMinute(min);
    setHour(hr);
    setDayOfMonth(dom);
    setMonth(mon);
    setDayOfWeek(dow);
  }, [value]);

  const handleChange = (field: string, selectedValue: string | number) => {
    const updated = {
      minute,
      hour,
      dayOfMonth,
      month,
      dayOfWeek,
      [field]: selectedValue
    }

    const cronString = `${updated.minute} ${updated.hour} ${updated.dayOfMonth} ${updated.month} ${updated.dayOfWeek}`;
    onChange(cronString);
  };

  const renderSelect = (label: string, value: string | number, onChange: (val: any) => void, options: (string | number)[]) => (
    <FormControl fullWidth size="small" sx={{ mr: 1, mb: 2, minWidth: 120 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="*">Every</MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>{opt}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" gap={2} sx={{pt:2}}>
      <Box>
        
        {renderSelect("Minute", minute, (val) => handleChange("minute", val), ranges.minute)}
      </Box>
      <Box>
        
        {renderSelect("Hour", hour, (val) => handleChange("hour", val), ranges.hour)}
      </Box>
      <Box>
       
        {renderSelect("Day of Month", dayOfMonth, (val) => handleChange("dayOfMonth", val), ranges.dayOfMonth)}
      </Box>
      <Box>
        
        {renderSelect("Month", month, (val) => handleChange("month", val), ranges.month)}
      </Box>
      <Box>
        
        {renderSelect("Day of Week", dayOfWeek, (val) => handleChange("dayOfWeek", val), ranges.dayOfWeek)}
      </Box>
    </Box>
  );
};

export default CronBuilder;
